import { createApp } from "vue";
import App from "./App.vue";
import "./assets/style/main.scss";
import router from "./router";
import { registerPinia } from "@/store";

const app = createApp(App);
registerPinia(app);

app.use(router);

app.mount("#app");
